import styled, { useTheme } from 'styled-components'
import { useEffect, useRef, useState } from 'react'

export const CanvasScatterplot = ({
  data,
  stage,
  yScale,
  xScale,
  width,
  height,
}: {
  data: any
  stage: number
  yScale: any
  xScale: any
  width: number
  height: number
}) => {
  const theme = useTheme()
  const canvasRef = useRef<HTMLCanvasElement>(null)
  const ctx = canvasRef.current?.getContext('2d')
  const scaleFactor = 2
  const dimensions = [width * scaleFactor, height * scaleFactor]
  let start: any = undefined
  const animation = useRef<any>(undefined)
  const totalAnimationDuration = 1000
  const circleAnimationDuration = 500
  const animationDuration = totalAnimationDuration - circleAnimationDuration

  const remainingDots = data.filter((d: any) => d.start < stage)
  const animatedDots = data.filter((d: any) => d.start === stage)

  const step = (timeStamp: any) => {
    if (!ctx) return

    ctx.clearRect(0, 0, dimensions[0], dimensions[1])

    if (start === undefined) {
      start = timeStamp
    }

    const elapsed = Math.min(totalAnimationDuration, timeStamp - start)
    const pct = elapsed / animationDuration

    animatedDots.forEach((d: any, i: any) => {
      const opacity =
        i === 0
          ? 1
          : Math.max(0, Math.min(1, 2 * (pct - i / (animatedDots.length - 1))))
      const radius = 6
      const opacityFactor = 1
      // TODO: fix this type shit
      const fillColor = d.highlight.includes(stage)
        ? theme.yellowColor
        : theme.yellowColor //@ts-ignore

      ctx.fillStyle = `rgba(${fillColor}, ${opacity * opacityFactor})`
      ctx.beginPath()
      ctx.arc(
        xScale(d.year) * scaleFactor,
        yScale(d.dayOfYear) * scaleFactor,
        radius * scaleFactor,
        0,
        2 * Math.PI
      )

      if (d.highlight.includes(stage)) {
        ctx.strokeStyle = theme.textColor
        ctx.lineWidth = 4
      } else {
        ctx.strokeStyle = `rgba(${theme.backgroundColorRGB}, ${opacity * opacityFactor})`
        ctx.lineWidth = 4
      }

      ctx.stroke()
      ctx.fill()
    })

    // Draw the points that remain (without transition)
    remainingDots.forEach((d: any) => {
      const fillColor =
        stage < 4
          ? d.highlight.includes(stage)
            ? theme.yellowColor
            : theme.yellowColor //@ts-ignore
          : theme.greyLight
      const radius = 6
      ctx.fillStyle = `rgba(${fillColor}, 1)`
      ctx.lineWidth = 4
      ctx.beginPath()
      ctx.arc(
        xScale(d.year) * scaleFactor,
        yScale(d.dayOfYear) * scaleFactor,
        radius * scaleFactor,
        0,
        2 * Math.PI
      )

      if (d.highlight.includes(stage)) {
        ctx.strokeStyle = theme.textColor
        ctx.lineWidth = 4
      } else {
        ctx.strokeStyle = `${theme.backgroundColor}`
        ctx.lineWidth = 4
      }

      ctx.stroke()
      ctx.fill()
    })

    if (elapsed < totalAnimationDuration) {
      animation.current = requestAnimationFrame(step)
    }
  }

  useEffect(() => {
    cancelAnimationFrame(animation.current)
    animation.current = requestAnimationFrame(step)
    start = undefined
  }, [data, stage, width, height])

  return <Canvas width={dimensions[0]} height={dimensions[1]} ref={canvasRef} />
}

const Canvas = styled.canvas`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`
